export default "__VITE_ASSET__Droi$uf8__"